var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Paper, styled } from '@mui/material';
export var OrgConfigStepPanel = styled(Paper)(function (_a) {
  var theme = _a.theme;
  return {
    padding: theme.spacing(8),
    borderRadius: theme.shape.borderRadius,
    height: '100%',
    overflow: 'auto'
  };
});
export var OrgConfigStepContainer = function (_a) {
  var leftContent = _a.leftContent,
    children = _a.children,
    rightContent = _a.rightContent,
    _b = _a.leftMd,
    leftMd = _b === void 0 ? 3 : _b,
    _c = _a.spacing,
    spacing = _c === void 0 ? 6 : _c;
  var centerMd = rightContent ? 12 - leftMd - 4 : 12 - leftMd;
  return _jsxs(Grid, __assign({
    container: true,
    spacing: spacing
  }, {
    children: [_jsx(Grid, __assign({
      item: true,
      xs: 12,
      md: leftMd
    }, {
      children: _jsx(OrgConfigStepPanel, __assign({
        sx: {
          bgcolor: 'primary.light'
        }
      }, {
        children: leftContent
      }))
    })), _jsx(Grid, __assign({
      item: true,
      xs: 12,
      md: centerMd
    }, {
      children: _jsx(OrgConfigStepPanel, {
        children: children
      })
    })), rightContent && _jsx(Grid, __assign({
      item: true,
      xs: 12,
      md: 4
    }, {
      children: _jsx(OrgConfigStepPanel, {
        children: rightContent
      })
    }))]
  }));
};